// extracted by mini-css-extract-plugin
export var closeButton = "_k5-1";
export var closeX = "_k5-3";
export var container = "_k5-0";
export var image = "_k5-2";